export const addDataConsumer = (dataConsumer, peerId) => ({
  type: "ADD_DATA_CONSUMER",
  payload: { dataConsumer, peerId },
});

export const removeDataConsumer = (dataConsumerId, peerId) => ({
  type: "REMOVE_DATA_CONSUMER",
  payload: { dataConsumerId, peerId },
});
